import { Basic } from 'src/app/core/models/basic.model';
import { MonthlyPaymentMode } from './monthly-payment.model';
import { ProductCategory } from './product-category.model';
import { ProductImage } from './product-image.model';
import { Service } from './service.model';

export class Product extends Basic<string> {
    public id: number;
    /**Precio */
    public price: number;
    /**Mínimo pago por mes de pagos mensuales */
    public monthlyMinimumAmount: number;
    // public monthlyPaymentMinAmountPerMonth: number;
    /**Máxima cantidad de años de pagos mensuales */
    public paymentYearMaximumCount: number;
    // public monthlyPaymentMaxYearCount: number;
    /**Descuento */
    public ofvDiscount: number;
    /**Es nuevo? */
    public isNew: boolean;
    /**Tiene oferta? */
    public hasOffer: boolean;
    /**Código SAP */
    public sapCode: string;
    /**Id de categoría */
    // public categoryId: number;
    /**Id de subcategoría */
    public subCategoryId: number;
    /**Id de marca */
    // public brandId: number;
    /**Id de sección */
    // public sectionId: number;
    /**Lista de características */
    public featureList: string[];
    /**Lista de modos de pago mensual */
    public monthlyPaymentModeList: MonthlyPaymentMode[];
    /**Categoría */
    public category: ProductCategory;
    /**Lista de imagenes */
    public imageList: ProductImage[];
    public serviceList: Service[];
    public orderItemId: number = 0;
    public count: number =  1;
    public categoriaFnbId : number;
    public aliadoComercialFnbId? : number;
}